import { ClientProxy } from '../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../base/models'
import { IPkSettingHistory } from '../models/models'

export class ListPkSettingHistoryApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/pesineKontrat/listSettingHistory',
      requesterInfo,
    })
  }

  public async listSettingHistory(): Promise<IPkSettingHistory[]> {
    return await this.getAsync<IPkSettingHistory[]>()
  }
}
